// src/api/Services/applicant.ts
import apiClient from "../client";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface ApplicantPayload {
  applicantName: string;
  email: string;
  phone: string;
  location: string;
  experience: string;
  linkedinLink?: string;
  websiteLink?: string;
  region?: string;
  jobId: string;
  coverLetter?: string;
  resumeFile: string; // fileId from upload
}

// ✅ Upload resume file
// applicant.ts
export const uploadResume = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await apiClient.post(
    `${API_BASE_URL}/intron/media/file/resume/upload`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );

  console.log("Upload Response:", res.data);

  // ✅ return attachmentId
  return res.data?.data?.attachmentId;
};



// ✅ Submit applicant info
export const submitApplicant = async (payload: ApplicantPayload) => {
  const res = await apiClient.post(
    `${API_BASE_URL}/intron/applicant/add`,
    payload
  );
  return res.data;
};
